"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getApiServerUrl = exports.getApiServerBaseUrl = void 0;

var _endsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/ends-with"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/starts-with"));

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));

/**
 * Gets the default api server's base url
 */
var getApiServerBaseUrl = function getApiServerBaseUrl() {
  var url = new _url.default(location.href);

  if (process.env.NODE_ENV === 'development') {
    var _context;

    if ((0, _startsWith.default)(_context = url.hostname).call(_context, 'localhost')) {
      url.port = '80';
    }
  }

  if (process.env.NODE_ENV === 'test') {
    url = new _url.default('http://mockapi.microsoft.com');
  }

  var prefix = process.env.APP_API_SERVER_OVERRIDE_PREFIX;

  if (prefix) {
    url.hostname = prefix + url.hostname.toLowerCase().replace('myapps', 'myapplications'); // api.myapps-ppe.microsoft.com is not supported. Replace it with api.myapplications-ppe
  }

  if (process.env.APP_API_SERVER_OVERRIDE) {
    url = new _url.default(process.env.APP_API_SERVER_OVERRIDE);
  }

  if (process.env.APP_API_SERVER_OVERRIDE_PORT) {
    url.port = process.env.APP_API_SERVER_OVERRIDE_PORT;
  }

  url.pathname = '/';
  url.hash = '';
  url.search = '';
  return url;
};
/**
 * Builds a url to hit a specific api endpoint
 * @param pathName The path name of the api
 * @param queryStringParams The query string parameters
 * @param encode This parameter is only respected when mocking is enabled
 * @param baseUrlOverride This parameter overrides the default logic to determine the api url
 */


exports.getApiServerBaseUrl = getApiServerBaseUrl;

var getApiServerUrl = function getApiServerUrl(pathName) {
  var queryStringParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var encode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var hostOverride = arguments.length > 3 ? arguments[3] : undefined;
  var url = getApiServerBaseUrl();

  if (hostOverride !== undefined) {
    url.host = hostOverride;
  }

  url.pathname = pathName;

  if (process.env.APP_DEV_ENABLE_MOCKS !== 'true' && encode) {
    var _context2;

    (0, _forEach.default)(_context2 = (0, _keys.default)(queryStringParams)).call(_context2, function (key) {
      var value = queryStringParams[key];

      if (value !== undefined) {
        url.searchParams.set(key, value);
      }
    });
  } else {
    var _context3;

    // This option should get dead code removed on production builds where mocks are disabled
    var search = '';
    (0, _forEach.default)(_context3 = (0, _keys.default)(queryStringParams)).call(_context3, function (key, index) {
      var value = queryStringParams[key];

      if (value !== undefined) {
        if (index === 0) {
          search += key + '=' + value;
        } else {
          search += '&' + key + '=' + value;
        }
      }
    });
    url.search = search;
  } // Workaround for Edge url pollyfill issue


  var uri = url.toString().replace('#', '');

  if ((0, _endsWith.default)(uri).call(uri, '?')) {
    uri.replace('?', '');
  }

  return uri;
};

exports.getApiServerUrl = getApiServerUrl;